import type { SelectionStore } from "./store.ts";
import type { EditorHost } from "./types.ts";

/**
 * Wire an implementing host's selection events into the package store.
 * Copies the current host selection first, then forwards later events.
 * Think still only reads the store — it does not subscribe to the host.
 */
export function bindHostToStore(host: EditorHost, store: SelectionStore): () => void {
  const stop = host.onSelectionChange((snapshot) => {
    store.set(snapshot);
  });
  store.set(host.getSelection());
  return stop;
}
